module.exports = __webpack_public_path__ + "img/2.8bbcb115.png";